module.exports = __webpack_public_path__ + "static/divider8-f6fe2a7b5a4c080a0097d81ad4d4b34f.svg";